import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=ae2af3ae&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=ae2af3ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2af3ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae2af3ae')) {
      api.createRecord('ae2af3ae', component.options)
    } else {
      api.reload('ae2af3ae', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=ae2af3ae&scoped=true&", function () {
      api.rerender('ae2af3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V0jqQNr6L1JH/JS/comp/CookieBox.vue"
export default component.exports